import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useState } from "react";
import { RaiseColors } from "client/componentLibrary";
import Typography from "componentLibrary/MuiComponentWrappers/Typography/Typography";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TextLink = function TextLink(_ref) {
  var leadingIcon = _ref.leadingIcon,
    trailingIcon = _ref.trailingIcon,
    onClick = _ref.onClick,
    children = _ref.children,
    useWarningColors = _ref.useWarningColors,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "body2" : _ref$variant,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? "medium" : _ref$weight;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isActive = _useState4[0],
    setIsActive = _useState4[1];
  var getColor = function getColor() {
    if (useWarningColors) {
      if (isActive && isHovered) return RaiseColors.destructive700;
      if (isHovered) return RaiseColors.jllRed;
      return RaiseColors.destructive500;
    } else {
      if (isActive && isHovered) return RaiseColors.teal;
      if (isHovered) return RaiseColors.blue1500;
      return RaiseColors.blue500;
    }
  };
  var handleMouseEnter = function handleMouseEnter() {
    return setIsHovered(true);
  };
  var handleMouseLeave = function handleMouseLeave() {
    setIsHovered(false);
    setIsActive(false);
  };
  var handleMouseDown = function handleMouseDown() {
    return setIsActive(true);
  };
  var handleMouseUp = function handleMouseUp() {
    return setIsActive(false);
  };
  return /*#__PURE__*/_jsxs(Typography, {
    onClick: onClick,
    variant: variant,
    weight: weight,
    color: getColor(),
    style: {
      cursor: "pointer"
    },
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    children: [leadingIcon ? /*#__PURE__*/_jsx("span", {
      className: leadingIcon
    }) : null, children, trailingIcon ? /*#__PURE__*/_jsx("span", {
      className: trailingIcon
    }) : null]
  });
};
export default TextLink;